import api from "../../../services/api";

export async function fetchOverviewDashboard(params: {
  start_date: string;
  end_date: string;
}) {
  const response = await api.get("/api/overview_dashboard", { params });
  return response.data;
}
